import React, { useCallback, useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { logoutSuccess, setCurrentPage } from "../../../store/auth/authReducer"
import { Navigate, useLocation } from "react-router-dom"
import axios from "axios"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import Snackbar from "@mui/material/Snackbar"
import Alert from "@mui/material/Alert"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import { useSelector } from "react-redux"
import { clearFilter } from "../../../store/filter/filterReducer"
import { prepareArray, prepareJSON } from "../../../utils/prepareJSON"
import Accordion, { AccordionProps } from "@mui/material/Accordion"
import { styled } from "@mui/material/styles"
import AccordionSummary from "@mui/material/AccordionSummary"
import Typography from "@mui/material/Typography"
import AccordionDetails from "@mui/material/AccordionDetails"
import 'handsontable/dist/handsontable.full.min.css';
import Handsontable from 'handsontable/base';
import { registerAllModules } from 'handsontable/registry';
import { HotTable } from '@handsontable/react';
import { logOut } from "../../../utils/logOut"
import { IconButton, Switch, Tooltip } from "@mui/material"
import { ExportData, ImportData } from "../../../utils/LanguageTableHelper"
import { formatSetFields, formatTerminatePlayText, parseSetFields, playtexttoarray, playtexttostring } from "../../../utils/ConversationTemplateSetupHelper"
import LanguageTable from "../../../components/Table/LanguageTable"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CodeMirror from '@uiw/react-codemirror';
import { langs } from '@uiw/codemirror-extensions-langs';
import { materialLight } from "@uiw/codemirror-theme-material"
import { Resizable } from "re-resizable"
import { debounce } from "../../../utils/debounce"
import TranslatedText from "../../../utils/Translate"
import { useSnackbar } from "../../../utils/SnackbarContext"

registerAllModules();

export default function AnalysisTemplate() {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [snackbarType, setSnackbarType] = useState("")
    const [partners, setSPartners] = useState([])
    const [expandedAccordion, setExpandedAccordion] = useState<any>([]);
    const [visibleAccordion, setVisibleAccordion] = useState<any>([]);

    const { showSnackbar } = useSnackbar();

    //Get params from URL
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const type: string | null = params.get('type')

    //Get access level
    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )



    useEffect(() => {
        //Switch header title
        dispatch(setCurrentPage(type === "edit" ? `Edit Analysis template` : type === "profile" ? `Profile` : 'Add Analysis Template'))
    }, [dispatch]);


    //Handle close snackbar
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    //Analisis cards func 
    const handleAccordionChange = (index: any) => {
        // Закрываем аккордеон
        if (expandedAccordion.includes(index) && visibleAccordion.includes(index)) {
            setExpandedAccordion(expandedAccordion.filter((el: any) => el !== index));
            setTimeout(() => {
                setVisibleAccordion(visibleAccordion.filter((el: any) => el !== index))
            }, 450);


        } else {
            // Открываем аккордеон
            setExpandedAccordion([...expandedAccordion, index]);
            setVisibleAccordion([...visibleAccordion, index])
        }
    };

    //Add analisis
    const handleAddAnalisis = () => {
        setAnalisisData({
            ...analisisData, analyzefreeinputdetails: {
                ...analisisData.analyzefreeinputdetails, analyzefreeinput: {
                    ...analisisData.analyzefreeinputdetails.analyzefreeinput,
                    labels: [...analisisData.analyzefreeinputdetails.analyzefreeinput.labels, ''],
                    priorities: [...analisisData.analyzefreeinputdetails.analyzefreeinput.priorities, -1],
                    wordssubstrings: [...analisisData.analyzefreeinputdetails.analyzefreeinput.wordssubstrings, [
                        [
                            "ru",
                            ""
                        ],
                        [
                            "Meaning",
                            "XXX"
                        ]
                    ]],
                    logicchecks: [...analisisData.analyzefreeinputdetails.analyzefreeinput.logicchecks, 0],
                    assertionnegation: [...analisisData.analyzefreeinputdetails.analyzefreeinput.assertionnegation, {}],
                    contexts: [...analisisData.analyzefreeinputdetails.analyzefreeinput.contexts, ""],
                    playtexts: [...analisisData.analyzefreeinputdetails.analyzefreeinput.playtexts, ""],
                    dirtyfields: [...analisisData.analyzefreeinputdetails.analyzefreeinput.dirtyfields, ""],
                    setfields: [...analisisData.analyzefreeinputdetails.analyzefreeinput.setfields, ""],
                }
            }
        })

    }

    //delete analisis
    const handleDeleteAnalisis = (index: any) => {
        console.log("Before deletion:", analisisData);

        setExpandedAccordion(expandedAccordion.filter((el: any) => el !== index));
        setVisibleAccordion(visibleAccordion.filter((el: any) => el !== index));

        setAnalisisData((prevAnalisisData: any) => {
            const newCommandData = { ...prevAnalisisData };
            // Remove from analyzefreeinput
            newCommandData.analyzefreeinputdetails.analyzefreeinput.labels = newCommandData.analyzefreeinputdetails.analyzefreeinput.labels.filter((el: any, i: any) => i !== index);
            newCommandData.analyzefreeinputdetails.analyzefreeinput.priorities = newCommandData.analyzefreeinputdetails.analyzefreeinput.priorities.filter((el: any, i: any) => i !== index);
            newCommandData.analyzefreeinputdetails.analyzefreeinput.wordssubstrings = newCommandData.analyzefreeinputdetails.analyzefreeinput.wordssubstrings.filter((el: any, i: any) => i !== index);
            newCommandData.analyzefreeinputdetails.analyzefreeinput.logicchecks = newCommandData.analyzefreeinputdetails.analyzefreeinput.logicchecks.filter((el: any, i: any) => i !== index);
            newCommandData.analyzefreeinputdetails.analyzefreeinput.assertionnegation = newCommandData.analyzefreeinputdetails.analyzefreeinput.assertionnegation.filter((el: any, i: any) => i !== index);
            newCommandData.analyzefreeinputdetails.analyzefreeinput.contexts = newCommandData.analyzefreeinputdetails.analyzefreeinput.contexts.filter((el: any, i: any) => i !== index);
            newCommandData.analyzefreeinputdetails.analyzefreeinput.playtexts = newCommandData.analyzefreeinputdetails.analyzefreeinput.playtexts.filter((el: any, i: any) => i !== index);
            newCommandData.analyzefreeinputdetails.analyzefreeinput.dirtyfields = newCommandData.analyzefreeinputdetails.analyzefreeinput.dirtyfields.filter((el: any, i: any) => i !== index);
            newCommandData.analyzefreeinputdetails.analyzefreeinput.setfields = newCommandData.analyzefreeinputdetails.analyzefreeinput.setfields.filter((el: any, i: any) => i !== index);

            return newCommandData;
        });

        console.log("After deletion:", analisisData);
    };

    //Transform depend arrays

    function transformObjectToArray(inputObject: any, arrayLength: any, fillType = 'object') {
        let result = []
        for (let i = 0; i < arrayLength; i++) {
            const element = inputObject[i];
            if (element === undefined) {
                if (fillType === 'object') {
                    result.push({})
                }
                else if (fillType === 'playtext') {
                    result.push('')
                }
                else if (fillType === 'dirtyfields') {
                    result.push('')
                }
                else {
                    result.push("")
                }

            }
            else {
                if (fillType === 'playtext') {
                    result.push(playtexttostring(element))
                }
                else if (fillType === 'dirtyfields') {
                    result.push(element.join(','))
                }
                else if (fillType === 'setfields') {
                    result.push(formatSetFields(element))
                }
                else
                    result.push(element)
            }

        }
        return result
    }

    function arrayToObjectWithIndexes(inputArray: any, convertType = 'object') {
        const resultObject: any = {};

        for (let i = 0; i < inputArray.length; i++) {
            const element = inputArray[i];

            // Проверка на пустой объект
            if (convertType == 'object') {
                if (Object.keys(element).length !== 0) {
                    resultObject[i] = element;
                }
            }
            else if (convertType == 'string') {
                if (element.length !== 0) {
                    resultObject[i] = element;
                }
            }
            else if (convertType == 'dirtyfields') {
                if (element.length !== 0) {
                    resultObject[i] = element.split(',');
                }
            }
            else if (convertType == 'playtext') {
                if (element.length !== 0) {
                    resultObject[i] = playtexttoarray(element);
                }
            }
            else if (convertType == 'setfields') {
                if (element.length !== 0) {
                    resultObject[i] = parseSetFields(element);
                }
            }

        }

        return resultObject;
    }


    //Get contact group
    async function fetchData(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/analysistemplate/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })

            if (response.data !== null) {
                if (typeof (response.data) === 'object') {

                    let analisisDetails = JSON.parse(response.data[0].analyzefreeinputdetails)

                    analisisDetails = {
                        analyzefreeinput: {
                            'analyzetemplates': (analisisDetails.analyzefreeinput.analyzetemplates !== undefined) ? analisisDetails.analyzefreeinput.analyzetemplates.join('\n') : "",
                            'ai_orchestration_prompts': (analisisDetails.analyzefreeinput.ai_orchestration_prompts !== undefined) ? analisisDetails.analyzefreeinput.ai_orchestration_prompts.join('\n') : "",
                            'labels': analisisDetails.analyzefreeinput.labels,
                            'wordssubstrings': Array.isArray(analisisDetails.analyzefreeinput.wordssubstrings) ? analisisDetails.analyzefreeinput.wordssubstrings.map((el: any) => ImportData(el)) : analisisDetails.analyzefreeinput.labels.map((el: any, index: any) => {
                                if (Object.keys(analisisDetails.analyzefreeinput.wordssubstrings).includes(index.toString())) {
                                    return ImportData(analisisDetails.analyzefreeinput.wordssubstrings[index])
                                }
                                else return ImportData([])
                            }),
                            'contexts': transformObjectToArray(analisisDetails.analyzefreeinput.contexts ? analisisDetails.analyzefreeinput.contexts : [], analisisDetails.analyzefreeinput.labels.length, 'string'),
                            'playtexts': transformObjectToArray(analisisDetails.analyzefreeinput.playtexts ? analisisDetails.analyzefreeinput.playtexts : [], analisisDetails.analyzefreeinput.labels.length, 'playtext'),
                            'dirtyfields': transformObjectToArray(analisisDetails.analyzefreeinput.dirtyfields ? analisisDetails.analyzefreeinput.dirtyfields : [], analisisDetails.analyzefreeinput.labels.length, 'dirtyfields'),
                            'setfields': transformObjectToArray(analisisDetails.analyzefreeinput.setfields ? analisisDetails.analyzefreeinput.setfields : [], analisisDetails.analyzefreeinput.labels.length, 'setfields'),
                            'terminatecondition': analisisDetails.analyzefreeinput.terminatecondition,
                            'terminateplaytext': playtexttostring(analisisDetails.analyzefreeinput.terminateplaytext),
                            'assenttexts': playtexttostring(analisisDetails.analyzefreeinput.assenttexts),
                            'ai_assenttexts': playtexttostring(analisisDetails.analyzefreeinput.ai_assenttexts),
                            'realtimestatuscode': analisisDetails.analyzefreeinput.realtimestatuscode,
                            'exitcode': analisisDetails.analyzefreeinput.exitcode,
                            'priorities': analisisDetails.analyzefreeinput.priorities,
                            'startcode': analisisDetails.analyzefreeinput.startcode,
                            'assertionnegation': (
                                analisisDetails.analyzefreeinput &&
                                analisisDetails.analyzefreeinput.assertionnegation !== undefined
                            )
                                ? transformObjectToArray(analisisDetails.analyzefreeinput.assertionnegation, analisisDetails.analyzefreeinput.labels.length)
                                : ((analisisDetails.analyzefreeinput && analisisDetails.analyzefreeinput.labels) || []).map(() => ({})),
                            'logicchecks': analisisDetails.analyzefreeinput.logicchecks,
                        }

                    }

                    setAnalisisData({ ...response.data[0], analyzefreeinputdetails: analisisDetails })
                    console.log(analisisData);

                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }

            console.log({ ...response.data[0], analyzefreeinputdetails: JSON.parse(response.data[0].analyzefreeinputdetails) });


        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Create contact group
    async function postData(data: any = {}) {
        try {
            const response = await axios.post(`https://cardgarantsales.com/restapi/analysistemplate`, {
                ...data,
                analyzefreeinputdetails: JSON.stringify({
                    analyzefreeinput: {
                        'analyzetemplates': data.analyzefreeinputdetails.analyzefreeinput.analyzetemplates.split('\n'),
                        'ai_orchestration_prompts': data.analyzefreeinputdetails.analyzefreeinput.ai_orchestration_prompts.split('\n'),
                        'labels': data.analyzefreeinputdetails.analyzefreeinput.labels,
                        'wordssubstrings': data.analyzefreeinputdetails.analyzefreeinput.wordssubstrings.map((el: any) => ExportData(el)['data']),
                        'contexts': arrayToObjectWithIndexes(data.analyzefreeinputdetails.analyzefreeinput.contexts, 'string'),
                        'playtexts': arrayToObjectWithIndexes(data.analyzefreeinputdetails.analyzefreeinput.playtexts, 'playtext'),
                        'dirtyfields': arrayToObjectWithIndexes(data.analyzefreeinputdetails.analyzefreeinput.dirtyfields, 'dirtyfields'),
                        'setfields': arrayToObjectWithIndexes(data.analyzefreeinputdetails.analyzefreeinput.setfields, 'setfields'),
                        'terminatecondition': data.analyzefreeinputdetails.analyzefreeinput.terminatecondition,
                        'terminateplaytext': playtexttoarray(data.analyzefreeinputdetails.analyzefreeinput.terminateplaytext),
                        'assenttexts': playtexttoarray(data.analyzefreeinputdetails.analyzefreeinput.assenttexts),
                        'ai_assenttexts': playtexttoarray(data.analyzefreeinputdetails.analyzefreeinput.ai_assenttexts),
                        'realtimestatuscode': data.analyzefreeinputdetails.analyzefreeinput.realtimestatuscode,
                        'exitcode': data.analyzefreeinputdetails.analyzefreeinput.exitcode,
                        'priorities': data.analyzefreeinputdetails.analyzefreeinput.priorities,
                        'assertionnegation': arrayToObjectWithIndexes(data.analyzefreeinputdetails.analyzefreeinput.assertionnegation),
                        'logicchecks': data.analyzefreeinputdetails.analyzefreeinput.logicchecks,
                        'startcode': data.analyzefreeinputdetails.analyzefreeinput.startcode
                    }
                })

            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Edit contact group
    async function putData(data: any = {}) {
        try {
            const response = await axios.put(`https://cardgarantsales.com/restapi/analysistemplate/${id}`, {
                ...data,
                analyzefreeinputdetails: JSON.stringify({
                    analyzefreeinput: {
                        'analyzetemplates': data.analyzefreeinputdetails.analyzefreeinput.analyzetemplates.split('\n'),
                        'ai_orchestration_prompts': data.analyzefreeinputdetails.analyzefreeinput.ai_orchestration_prompts.split('\n'),
                        'labels': data.analyzefreeinputdetails.analyzefreeinput.labels,
                        'wordssubstrings': data.analyzefreeinputdetails.analyzefreeinput.wordssubstrings.map((el: any) => ExportData(el)['data']),
                        'contexts': arrayToObjectWithIndexes(data.analyzefreeinputdetails.analyzefreeinput.contexts, 'string'),
                        'playtexts': arrayToObjectWithIndexes(data.analyzefreeinputdetails.analyzefreeinput.playtexts, 'playtext'),
                        'dirtyfields': arrayToObjectWithIndexes(data.analyzefreeinputdetails.analyzefreeinput.dirtyfields, 'dirtyfields'),
                        'setfields': arrayToObjectWithIndexes(data.analyzefreeinputdetails.analyzefreeinput.setfields, 'setfields'),
                        'terminatecondition': data.analyzefreeinputdetails.analyzefreeinput.terminatecondition,
                        'terminateplaytext': playtexttoarray(data.analyzefreeinputdetails.analyzefreeinput.terminateplaytext),
                        'assenttexts': playtexttoarray(data.analyzefreeinputdetails.analyzefreeinput.assenttexts),
                        'ai_assenttexts': playtexttoarray(data.analyzefreeinputdetails.analyzefreeinput.ai_assenttexts),
                        'realtimestatuscode': data.analyzefreeinputdetails.analyzefreeinput.realtimestatuscode,
                        'exitcode': data.analyzefreeinputdetails.analyzefreeinput.exitcode,
                        'priorities': data.analyzefreeinputdetails.analyzefreeinput.priorities,
                        'assertionnegation': arrayToObjectWithIndexes(data.analyzefreeinputdetails.analyzefreeinput.assertionnegation),
                        'logicchecks': data.analyzefreeinputdetails.analyzefreeinput.logicchecks,
                        'startcode': data.analyzefreeinputdetails.analyzefreeinput.startcode
                    }
                })

            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    const [analisisData, setAnalisisData] = useState<any>(type === 'edit' ? [] :
        {
            code: '',
            name: '',
            partner: '',
            partnerbankcode: '',
            showsetuptopartner: '1',
            analyzefreeinputdetails: {
                analyzefreeinput: {
                    'analyzetemplates': "",
                    'ai_orchestration_prompts': "",
                    'labels': [],
                    'startcode': '',
                    'wordssubstrings': [],
                    'contexts': "",
                    'playtexts': '',
                    'dirtyfields': '',
                    'setfields': '',
                    'terminatecondition': "",
                    'terminateplaytext': "",
                    'assenttexts': "",
                    'ai_assenttexts': "",
                    'realtimestatuscode': "",
                    'exitcode': "",
                    'priorities': [],
                    'logicchecks': [],
                    'assertionnegation': [],
                },
            }
        }

    )


    //Get partners for Select field
    async function getPartners(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/partner`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setSPartners(response.data)
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }


    //On load if URL params contains type=edit - get contactgroup data, if accesslevel = 5 - get partners for Select field
    useEffect(() => {
        type === 'edit' && fetchData()
        accesslevel === "5" && getPartners()
        console.log(analisisData);

    }, [type])


    console.log(analisisData);

    const handleDebounceChange = useCallback(
        debounce((set: any) => {
            setAnalisisData((prevState: any) => (set));
        }, 200),
        []
    );


    return (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <Box>

                <Box sx={{ maxWidth: 1220, width: '90vw', display: "flex", mb: 2, flexWrap: "wrap", gap: 2 }}>

                    <TextField key={analisisData.code} fullWidth error={analisisData.code == null} onBlur={(e) => setAnalisisData({ ...analisisData, code: e.target.value !== '' ? e.target.value : null })} defaultValue={analisisData.code || ''} variant="outlined" size="small" label={<TranslatedText text={'Code*'} />} />
                    <TextField key={analisisData.name} fullWidth onBlur={(e) => setAnalisisData({ ...analisisData, name: e.target.value !== '' ? e.target.value : null })} defaultValue={analisisData.name || ''} variant="outlined" size="small" label={<TranslatedText text={'Name'} />} />
                    {(accesslevel === '5' && !Array.isArray(analisisData)) &&
                        <>
                            <FormControl fullWidth>
                                <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Availability'} /></InputLabel>
                                <Select fullWidth labelId="simple-select-label" value={analisisData.partner} onChange={(e) => setAnalisisData({ ...analisisData, partner: e.target.value })} variant="outlined" size="small" label={<TranslatedText text={'Availability'} />} >
                                    <MenuItem value={''}>Only Operators</MenuItem>
                                    <MenuItem value={'0'}>Everyone</MenuItem>
                                    {
                                        partners.map((el: any) => {
                                            return (
                                                <MenuItem key={el.id} value={el.id}>{el.partnerbankcode}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <Box sx={{ display: "flex", alignItems: "center", width: 223, pl: 2 }}>
                                <Typography><TranslatedText text={'Allow editing'} /></Typography>
                                <Switch onChange={(e) => setAnalisisData({ ...analisisData, showsetuptopartner: analisisData.showsetuptopartner === '0' ? '1' : '0' })} checked={Boolean(+analisisData.showsetuptopartner)} />
                            </Box>
                        </>

                    }
                    <Tooltip title={<TranslatedText text={"Upload Client Questions Analysis templates (names of each template on a new line)"} />} placement="top-start">
                        <TextField sx={{ width: "100%", '& textarea': { resize: 'vertical' }, mb: 2 }}
                            label={<TranslatedText text={"Upload Client Questions Analysis templates"} />}
                            onBlur={(e) => setAnalisisData({ ...analisisData, analyzefreeinputdetails: { ...analisisData.analyzefreeinputdetails, analyzefreeinput: { ...analisisData.analyzefreeinputdetails.analyzefreeinput, analyzetemplates: e.target.value !== '' ? e.target.value : '' } } })}
                            defaultValue={analisisData.analyzefreeinputdetails !== undefined ? analisisData.analyzefreeinputdetails.analyzefreeinput.analyzetemplates : ''}
                            multiline
                            rows={5}
                            key={analisisData.analyzefreeinputdetails}
                            fullWidth
                            variant="outlined" />
                    </Tooltip>

                    <Tooltip title={<TranslatedText text={"Names of AI prompts for orchestration (each name on a new line)"} />} placement="top-start">
                        <TextField sx={{ width: "100%", '& textarea': { resize: 'vertical' }, mb: 2 }}
                            label={<TranslatedText text={"Names of AI prompts for orchestration"} />}
                            onBlur={(e) => setAnalisisData({ ...analisisData, analyzefreeinputdetails: { ...analisisData.analyzefreeinputdetails, analyzefreeinput: { ...analisisData.analyzefreeinputdetails.analyzefreeinput, ai_orchestration_prompts: e.target.value !== '' ? e.target.value : '' } } })}
                            defaultValue={analisisData.analyzefreeinputdetails !== undefined ? analisisData.analyzefreeinputdetails.analyzefreeinput.ai_orchestration_prompts : ''}
                            multiline
                            rows={5}
                            key={analisisData.analyzefreeinputdetails}
                            fullWidth
                            variant="outlined" />
                    </Tooltip>

                    <Box sx={{ width: '100%', padding: 4, border: '1px solid #c4c4c4', borderRadius: 2, mb: 2 }}>
                        <Typography mb={2} variant="h6" width={'100%'} textAlign={'center'}><TranslatedText text={'Analysis options'} /></Typography>
                        {

                            !Array.isArray(analisisData) && analisisData.analyzefreeinputdetails.analyzefreeinput.labels.map((el: any, index: any) => {

                                return (
                                    <Accordion expanded={expandedAccordion.includes(index)} onChange={() => handleAccordionChange(index)} key={el + index} sx={{ width: '100%', border: '1px solid #c4c4c4', borderRadius: 2, padding: 1, mb: 2 }}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Box sx={{ width: '100%' }}>
                                                <IconButton onClick={(e) => { e.stopPropagation(); handleDeleteAnalisis(index) }} aria-label="delete" color="error">
                                                    <DeleteForeverIcon />
                                                </IconButton>
                                                <TextField sx={{ width: '50%', ml: 2 }} onClick={(e) => e.stopPropagation()} onBlur={(e) => setAnalisisData({ ...analisisData, analyzefreeinputdetails: { ...analisisData.analyzefreeinputdetails, analyzefreeinput: { ...analisisData.analyzefreeinputdetails.analyzefreeinput, labels: analisisData.analyzefreeinputdetails.analyzefreeinput.labels.map((element: any, i: any) => (i === index ? e.target.value : element)) } } })} defaultValue={analisisData.analyzefreeinputdetails.analyzefreeinput.labels[index] || ''} variant="outlined" size="small" label={<TranslatedText text={'Name of the analysis'} />} />
                                            </Box>


                                        </AccordionSummary>
                                        <AccordionDetails sx={{ overflow: 'auto' }}>
                                            {visibleAccordion.includes(index) && <>
                                                <Box sx={{ gap: 2, display: 'flex', mb: 2 }}>
                                                    <TextField onBlur={(e) => setAnalisisData({
                                                        ...analisisData, analyzefreeinputdetails: {
                                                            ...analisisData.analyzefreeinputdetails, analyzefreeinput: {
                                                                ...analisisData.analyzefreeinputdetails.analyzefreeinput, assertionnegation: analisisData.analyzefreeinputdetails.analyzefreeinput.assertionnegation.map((el: any, i: any) => {
                                                                    if (i == index) {
                                                                        return { ...el, assertion: e.target.value }
                                                                    }
                                                                    else return el
                                                                })
                                                            }
                                                        }
                                                    })} defaultValue={analisisData.analyzefreeinputdetails.analyzefreeinput.assertionnegation[index] != undefined ? analisisData.analyzefreeinputdetails.analyzefreeinput.assertionnegation[index].assertion : ''} variant="outlined" size="small" label={<TranslatedText text={'Assertion'} />} />
                                                    <TextField onBlur={(e) => setAnalisisData({
                                                        ...analisisData, analyzefreeinputdetails: {
                                                            ...analisisData.analyzefreeinputdetails, analyzefreeinput: {
                                                                ...analisisData.analyzefreeinputdetails.analyzefreeinput, assertionnegation: analisisData.analyzefreeinputdetails.analyzefreeinput.assertionnegation.map((el: any, i: any) => {
                                                                    if (i == index) {
                                                                        return { ...el, negation: e.target.value }
                                                                    }
                                                                    else return el
                                                                })
                                                            }
                                                        }
                                                    })} defaultValue={analisisData.analyzefreeinputdetails.analyzefreeinput.assertionnegation[index] != undefined ? analisisData.analyzefreeinputdetails.analyzefreeinput.assertionnegation[index].negation : ''} variant="outlined" size="small" label={<TranslatedText text={'Negating'} />} />
                                                    <TextField onBlur={(e) => setAnalisisData({
                                                        ...analisisData, analyzefreeinputdetails: {
                                                            ...analisisData.analyzefreeinputdetails, analyzefreeinput: {
                                                                ...analisisData.analyzefreeinputdetails.analyzefreeinput, assertionnegation: analisisData.analyzefreeinputdetails.analyzefreeinput.assertionnegation.map((el: any, i: any) => {
                                                                    if (i == index) {
                                                                        return { ...el, question: e.target.value }
                                                                    }
                                                                    else return el
                                                                })
                                                            }
                                                        }
                                                    })} defaultValue={analisisData.analyzefreeinputdetails.analyzefreeinput.assertionnegation[index] != undefined ? analisisData.analyzefreeinputdetails.analyzefreeinput.assertionnegation[index].question : ''} variant="outlined" size="small" label={<TranslatedText text={'Question'} />} />
                                                    <TextField onBlur={(e) => setAnalisisData({
                                                        ...analisisData, analyzefreeinputdetails: {
                                                            ...analisisData.analyzefreeinputdetails, analyzefreeinput: {
                                                                ...analisisData.analyzefreeinputdetails.analyzefreeinput, assertionnegation: analisisData.analyzefreeinputdetails.analyzefreeinput.assertionnegation.map((el: any, i: any) => {
                                                                    if (i == index) {
                                                                        return { ...el, conditional: e.target.value }
                                                                    }
                                                                    else return el
                                                                })
                                                            }
                                                        }
                                                    })} defaultValue={analisisData.analyzefreeinputdetails.analyzefreeinput.assertionnegation[index] != undefined ? analisisData.analyzefreeinputdetails.analyzefreeinput.assertionnegation[index].conditional : ''} variant="outlined" size="small" label={<TranslatedText text={'Conditional'} />} />
                                                </Box>
                                                <TextField sx={{ width: '100%', mb: 2, '& textarea': { resize: 'vertical' } }} multiline onBlur={(e) => setAnalisisData({
                                                    ...analisisData, analyzefreeinputdetails: {
                                                        ...analisisData.analyzefreeinputdetails, analyzefreeinput: {
                                                            ...analisisData.analyzefreeinputdetails.analyzefreeinput, contexts: analisisData.analyzefreeinputdetails.analyzefreeinput.contexts.map((el: any, i: any) => {
                                                                if (i == index) {
                                                                    return e.target.value
                                                                }
                                                                else return el
                                                            })
                                                        }
                                                    }
                                                })} defaultValue={analisisData.analyzefreeinputdetails.analyzefreeinput.contexts[index] != undefined ? analisisData.analyzefreeinputdetails.analyzefreeinput.contexts[index] : ''} variant="outlined" size="small" label={<TranslatedText text={'Context'} />} />
                                                <TextField sx={{ width: '100%', mb: 2, '& textarea': { resize: 'vertical' } }} multiline onBlur={(e) => setAnalisisData({
                                                    ...analisisData, analyzefreeinputdetails: {
                                                        ...analisisData.analyzefreeinputdetails, analyzefreeinput: {
                                                            ...analisisData.analyzefreeinputdetails.analyzefreeinput, playtexts: analisisData.analyzefreeinputdetails.analyzefreeinput.playtexts.map((el: any, i: any) => {
                                                                if (i == index) {
                                                                    return e.target.value
                                                                }
                                                                else return el
                                                            })
                                                        }
                                                    }
                                                })} defaultValue={analisisData.analyzefreeinputdetails.analyzefreeinput.playtexts[index] != undefined ? analisisData.analyzefreeinputdetails.analyzefreeinput.playtexts[index] : ''} variant="outlined" size="small" label={<TranslatedText text={'The text of the message for various options'} />} />
                                                <TextField sx={{ width: '100%', mb: 2, '& textarea': { resize: 'vertical' } }} multiline onBlur={(e) => setAnalisisData({
                                                    ...analisisData, analyzefreeinputdetails: {
                                                        ...analisisData.analyzefreeinputdetails, analyzefreeinput: {
                                                            ...analisisData.analyzefreeinputdetails.analyzefreeinput, dirtyfields: analisisData.analyzefreeinputdetails.analyzefreeinput.dirtyfields.map((el: any, i: any) => {
                                                                if (i == index) {
                                                                    return e.target.value
                                                                }
                                                                else return el
                                                            })
                                                        }
                                                    }
                                                })} defaultValue={analisisData.analyzefreeinputdetails.analyzefreeinput.dirtyfields[index] != undefined ? analisisData.analyzefreeinputdetails.analyzefreeinput.dirtyfields[index] : ''} variant="outlined" size="small" label={<TranslatedText text={'The names of irrelevant fields that need to be asked again'} />} />
                                                <TextField sx={{ width: '100%', mb: 2, '& textarea': { resize: 'vertical' } }} multiline onBlur={(e) => setAnalisisData({
                                                    ...analisisData, analyzefreeinputdetails: {
                                                        ...analisisData.analyzefreeinputdetails, analyzefreeinput: {
                                                            ...analisisData.analyzefreeinputdetails.analyzefreeinput, setfields: analisisData.analyzefreeinputdetails.analyzefreeinput.setfields.map((el: any, i: any) => {
                                                                if (i == index) {
                                                                    return e.target.value
                                                                }
                                                                else return el
                                                            })
                                                        }
                                                    }
                                                })} defaultValue={analisisData.analyzefreeinputdetails.analyzefreeinput.setfields[index] != undefined ? analisisData.analyzefreeinputdetails.analyzefreeinput.setfields[index] : ''} variant="outlined" size="small" label={<TranslatedText text={'Fields to be set'} />} />

                                                <LanguageTable setTableData={(e: any) => setAnalisisData({ ...analisisData, analyzefreeinputdetails: { ...analisisData.analyzefreeinputdetails, analyzefreeinput: { ...analisisData.analyzefreeinputdetails.analyzefreeinput, wordssubstrings: analisisData.analyzefreeinputdetails.analyzefreeinput.wordssubstrings.map((element: any, i: any) => (i === index ? e : element)) } } })} tableData={analisisData.analyzefreeinputdetails.analyzefreeinput !== undefined ? analisisData.analyzefreeinputdetails.analyzefreeinput.wordssubstrings[index] != undefined ? analisisData.analyzefreeinputdetails.analyzefreeinput.wordssubstrings[index] : ImportData([]) : []} />
                                            </>}
                                        </AccordionDetails>
                                    </Accordion>

                                )
                            })
                        }
                        <Button onClick={() => handleAddAnalisis()} variant="contained" sx={{ width: "100%" }}><TranslatedText text={'Add analysis'} /></Button>
                    </Box>



                    {!Array.isArray(analisisData) &&
                        <>
                            <Tooltip title={<TranslatedText text={'The code of the conditions for calling complex options for Analyzing clients questions (the terminate option is to stop the conversation; first this code is executed, then from the templates for Analyzing clients questions, but if "return" occurs, then the code from the templates will not be executed)'} />} placement="top-start">
                                {/* <TextField sx={{ width: "100%", '& textarea': { resize: 'vertical' }, mb: 2 }}
                                    label="The code of the conditions for calling complex options for Analyzing clients questions"
                                    onChange={(e) => setAnalisisData({ ...analisisData, analyzefreeinputdetails: { ...analisisData.analyzefreeinputdetails, analyzefreeinput: { ...analisisData.analyzefreeinputdetails.analyzefreeinput, terminatecondition: e.target.value !== '' ? e.target.value : '' } } })}
                                    value={analisisData.analyzefreeinputdetails.analyzefreeinput !== undefined ? analisisData.analyzefreeinputdetails.analyzefreeinput.terminatecondition : ''}
                                    multiline
                                    rows={5}
                                    fullWidth
                                    variant="outlined" /> */}
                                <Box sx={{ width: '100%', border: '1px solid #c4c4c4', borderRadius: 2, paddingTop: 1, paddingBottom: 1, paddingLeft: 1, paddingRight: 1, mb: 2 }}>
                                    <Typography sx={{ opacity: '0.6' }} fontSize={17} mb={1} ml={2} ><TranslatedText text={'The code of the conditions for calling complex options for Analyzing clients questions'} /></Typography>
                                    <CodeMirror
                                        width="auto"
                                        maxHeight="200px"
                                        onChange={(e) => handleDebounceChange({ ...analisisData, analyzefreeinputdetails: { ...analisisData.analyzefreeinputdetails, analyzefreeinput: { ...analisisData.analyzefreeinputdetails.analyzefreeinput, terminatecondition: e !== '' ? e : '' } } })}
                                        value={analisisData.analyzefreeinputdetails.analyzefreeinput !== undefined ? analisisData.analyzefreeinputdetails.analyzefreeinput.terminatecondition : ''}
                                        theme={materialLight} extensions={[langs.javascript()]} />
                                </Box>
                            </Tooltip>
                            <Tooltip title={<TranslatedText text={'The text of the message for the option to terminate the conversation by condition (the terminate option) (for pre-recorded audio fragments, #, /, <p...>, <t...> are used, for example, #audio fragments-dates/April#audio fragments-dates/<p0.8><t1.2>(p-tone,t-speed)2021)'} />} placement="top-start">
                                <TextField sx={{ width: "100%", '& textarea': { resize: 'vertical' }, mb: 2 }}
                                    label={<TranslatedText text={"The text of the message for the option to terminate the conversation by condition"} />}
                                    onBlur={(e) => setAnalisisData({ ...analisisData, analyzefreeinputdetails: { ...analisisData.analyzefreeinputdetails, analyzefreeinput: { ...analisisData.analyzefreeinputdetails.analyzefreeinput, terminateplaytext: e.target.value !== '' ? e.target.value : '' } } })}
                                    defaultValue={analisisData.analyzefreeinputdetails.analyzefreeinput !== undefined ? analisisData.analyzefreeinputdetails.analyzefreeinput.terminateplaytext : ''}
                                    multiline
                                    rows={5}
                                    fullWidth
                                    variant="outlined" />
                            </Tooltip>
                            <Tooltip title={<TranslatedText text={'The texts of the "assent" messages (for pre-recorded audio fragments, #, /, <p...>, <t...> are used, for example, #audio fragments-assent/uh-huh <p0.8><t1.2>(p-tone,t-speed)'} />} placement="top-start">
                                <TextField sx={{ width: "100%", '& textarea': { resize: 'vertical' }, mb: 2 }}
                                    label={<TranslatedText text={'The texts of the "assent" messages'} />}
                                    onBlur={(e) => setAnalisisData({ ...analisisData, analyzefreeinputdetails: { ...analisisData.analyzefreeinputdetails, analyzefreeinput: { ...analisisData.analyzefreeinputdetails.analyzefreeinput, assenttexts: e.target.value !== '' ? e.target.value : '' } } })}
                                    defaultValue={analisisData.analyzefreeinputdetails.analyzefreeinput !== undefined ? analisisData.analyzefreeinputdetails.analyzefreeinput.assenttexts : ''}
                                    multiline
                                    rows={5}
                                    fullWidth
                                    variant="outlined" />
                            </Tooltip>
                            <Tooltip title={<TranslatedText text={'The texts of the "assent" messages when the AI is launched (for pre-recorded audio fragments, #, /, <p...>, <t...> are used, for example, #audio fragments-assent/uh-huh <p0.8><t1.2>(p-tone,t-speed)'} />} placement="top-start">
                                <TextField sx={{ width: "100%", '& textarea': { resize: 'vertical' }, mb: 2 }}
                                    label={<TranslatedText text={'The texts of the "assent" messages when the AI is launched'} />}
                                    onBlur={(e) => setAnalisisData({ ...analisisData, analyzefreeinputdetails: { ...analisisData.analyzefreeinputdetails, analyzefreeinput: { ...analisisData.analyzefreeinputdetails.analyzefreeinput, ai_assenttexts: e.target.value !== '' ? e.target.value : '' } } })}
                                    defaultValue={analisisData.analyzefreeinputdetails.analyzefreeinput !== undefined ? analisisData.analyzefreeinputdetails.analyzefreeinput.ai_assenttexts : ''}
                                    multiline
                                    rows={5}
                                    fullWidth
                                    variant="outlined" />
                            </Tooltip>
                            <Tooltip title={<TranslatedText text={'The code executed at the beginning of the conversation (before audio fragments are synthesized; this code is executed first, then from the clients Question Analysis templates, but if "return" occurs, then the code from the templates will not be executed)'} />} placement="top-start">
                                <Box sx={{ width: '100%', border: '1px solid #c4c4c4', borderRadius: 2, paddingTop: 1, paddingBottom: 1, paddingLeft: 1, paddingRight: 1, mb: 2 }}>
                                    <Typography sx={{ opacity: '0.6' }} fontSize={17} mb={1} ml={2} ><TranslatedText text={'The code executed at the beginning of the conversation'} /></Typography>
                                    <CodeMirror
                                        width="auto"
                                        maxHeight="200px"
                                        onChange={(e) => handleDebounceChange({ ...analisisData, analyzefreeinputdetails: { ...analisisData.analyzefreeinputdetails, analyzefreeinput: { ...analisisData.analyzefreeinputdetails.analyzefreeinput, startcode: e !== '' ? e : '' } } })}
                                        value={analisisData.analyzefreeinputdetails.analyzefreeinput.startcode !== undefined ? analisisData.analyzefreeinputdetails.analyzefreeinput.startcode : ''}
                                        theme={materialLight} extensions={[langs.javascript()]} />
                                </Box>
                            </Tooltip>
                            <Tooltip title={<TranslatedText text={'The code for calculating the unified conversation status (this code is executed first, then from the clients Question Analysis templates, but if "return" occurs, then the code from the templates will not be executed)'} />} placement="top-start">
                                <Box sx={{ width: '100%', border: '1px solid #c4c4c4', borderRadius: 2, paddingTop: 1, paddingBottom: 1, paddingLeft: 1, paddingRight: 1, mb: 2 }}>
                                    <Typography sx={{ opacity: '0.6' }} fontSize={17} mb={1} ml={2} ><TranslatedText text={'The code for calculating the unified conversation status'} /></Typography>
                                    <CodeMirror
                                        width="auto"
                                        maxHeight="200px"
                                        value={analisisData.analyzefreeinputdetails.analyzefreeinput !== undefined ? analisisData.analyzefreeinputdetails.analyzefreeinput.realtimestatuscode : ''}
                                        onChange={(e) => handleDebounceChange({ ...analisisData, analyzefreeinputdetails: { ...analisisData.analyzefreeinputdetails, analyzefreeinput: { ...analisisData.analyzefreeinputdetails.analyzefreeinput, realtimestatuscode: e !== '' ? e : '' } } })}
                                        theme={materialLight} extensions={[langs.javascript()]} />
                                </Box>
                            </Tooltip>
                            <Tooltip title={<TranslatedText text={'The code executed at the end of the conversation (to export the results of the conversation to external systems; first, this code is executed, then from the clients Question Analysis templates, but if "return" is encountered, then the code from the templates will not be executed)'} />} placement="top-start">
                                <Box sx={{ width: '100%', border: '1px solid #c4c4c4', borderRadius: 2, paddingTop: 1, paddingBottom: 1, paddingLeft: 1, paddingRight: 1, mb: 2 }}>
                                    <Typography sx={{ opacity: '0.6' }} fontSize={17} mb={1} ml={2} ><TranslatedText text={'The code executed at the end of the conversation'} /></Typography>
                                    <CodeMirror
                                        width="auto"
                                        maxHeight="200px"
                                        onChange={(e) => handleDebounceChange({
                                            ...analisisData,
                                            analyzefreeinputdetails: {
                                                ...analisisData.analyzefreeinputdetails,
                                                analyzefreeinput: {
                                                    ...analisisData.analyzefreeinputdetails.analyzefreeinput,
                                                    exitcode: e !== '' ? e : ''
                                                }
                                            }
                                        })}
                                        value={analisisData.analyzefreeinputdetails.analyzefreeinput !== undefined ? analisisData.analyzefreeinputdetails.analyzefreeinput.exitcode : ''}
                                        theme={materialLight} extensions={[langs.javascript()]} />
                                </Box>
                                {/* <TextField sx={{ width: "100%", '& textarea': { resize: 'vertical' }, mb: 2 }}
                                    label='The code executed at the end of the conversation'
                                    onChange={(e) => setAnalisisData({ ...analisisData, analyzefreeinputdetails: { ...analisisData.analyzefreeinputdetails, analyzefreeinput: { ...analisisData.analyzefreeinputdetails.analyzefreeinput, exitcode: e.target.value !== '' ? e.target.value : '' } } })}
                                    value={analisisData.analyzefreeinputdetails.analyzefreeinput !== undefined ? analisisData.analyzefreeinputdetails.analyzefreeinput.exitcode : ''}
                                    multiline
                                    rows={5}
                                    fullWidth
                                    variant="outlined" /> */}
                            </Tooltip>

                        </>
                    }


                </Box>
                {accesslevel === '5' && <Button onClick={() => type === "edit" ? putData(analisisData) : postData(analisisData)} variant="contained" sx={{ width: "100%" }}><TranslatedText text={'Save'} /></Button>}
            </Box>
            {type !== 'edit' && snackbarType === 'success' && <Navigate to='/analysistemplates' />}
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleClose}>
                {snackbarType === 'error' ?
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                        <TranslatedText text={'Saving error'} />
                    </Alert> :
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        <TranslatedText text={'Successfully saved'} />
                    </Alert>}
            </Snackbar>
        </Box >
    )
}

